import "core-js/modules/es.array.concat.js";
import http from '@/plugins/axios';
import store from '@/store';
var VERSION = 'v2';
var RESOURCE = 'nps';
var BASE_URL = "".concat(VERSION, "/").concat(RESOURCE);
export default {
  getNps: function getNps(params) {
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.get("".concat(empresa.url_instancia, "/").concat(BASE_URL), {
      params: params
    });
  },
  getNpsEspecifico: function getNpsEspecifico(params) {
    var npsId = params.npsId;
    delete params.npsId;
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.get("".concat(empresa.url_instancia, "/").concat(BASE_URL, "/").concat(npsId), {
      params: params
    });
  },
  registrarResposta: function registrarResposta(payload) {
    var empresa = store.state.auth.empresa;
    if (payload.id) {
      return http.apiEmpresa.put("".concat(empresa.url_instancia, "/").concat(BASE_URL, "/resposta"), payload);
    } else {
      return http.apiEmpresa.post("".concat(empresa.url_instancia, "/").concat(BASE_URL, "/resposta"), payload);
    }
  },
  atualizarResposta: function atualizarResposta(payload) {
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.patch("".concat(empresa.url_instancia, "/").concat(BASE_URL, "/resposta"), payload);
  }
};